import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { PostHubService } from '../post-hub.service'
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
@Component({
  selector: 'app-post-list',
  templateUrl: './post-list.component.html',
  styleUrls: ['./post-list.component.css'],
})
export class PostListComponent implements OnInit {
  sortIconStartTimeSrc: string = "assets/uparrow.svg";
  sortIconReactionSrc: string = "assets/uparrow.svg";
  searchValue: string;
  botListArray: any;
  loginUserDetails: any;
  merchantId: string;
  horizontalPosition: MatSnackBarHorizontalPosition = 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  allBotConfigurationDetails: Array<any> = [];
  dropdown_botname = "";
  botSelected = "";
  dropdown_icon: boolean = false;
  botSelectedImage = '';
  allBotPosts: any[] = [];
  startFilterDate = "";
  endFilterDate = "";
  allPostMasterData : any;
  uniquePostTypes: string[] = [];
  selectedFilter: string = 'Post type';
  postListType = "Published";
  start_time: string;
  end_time: string;
  currentPage = 1;
  limit = 100;
  totalItems = 0;
  visiblePageCount = 2;
  offset = 0;
  today = new Date();
  ngOnInit(): void {
    this.loginUserDetails = JSON.parse(
      localStorage.getItem('loginUserDetails')
    );
    this.merchantId = this.loginUserDetails.merchant_id;
    this.getAllBotDetails();
  }
  constructor(
    private postHubService: PostHubService, 
    private _snackBar: MatSnackBar,
    private router : Router
    ) { }
  getAllBotDetails() {
    this.postHubService.getBotDetailsByMerchantId(this.merchantId).subscribe(
      (res) => {
        this.botListArray = res.body.data;
        setTimeout(() => {
          if (res.body.data[0]?.bot_id) {
            this.botSelected = res.body.data[0]?.bot_id;
            this.dropdown_botname = res.body.data[0]?.name;
            this.getPostByBotId(this.botSelected)
            this.botSelectedImage = this.allBotConfigurationDetails[0]?.photo;
          }
        }, 300)
        this.postHubService.requestMultipleBotConfigurationById(this.botListArray)
          .subscribe((responseList) => {
            responseList.forEach((element) => {
              this.allBotConfigurationDetails.push(element.body);
            });
          });
      },
      (error) => {
        let errorMessage = error.error.message ? error.error.message : "Something Went Wrong";
        this._snackBar.open(errorMessage, 'close', {
          duration: 3000,
          horizontalPosition: this.horizontalPosition,
          verticalPosition: this.verticalPosition,
        });
      }
    )
  }
  iconChange() {
    this.dropdown_icon = !this.dropdown_icon
  }

  formatDateLocal(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  getPostByBotId(botId) {
    this.offset = (this.currentPage - 1) * this.limit;
    if (this.startFilterDate && this.endFilterDate) {
      const start = new Date(this.startFilterDate);
      start.setHours(0, 0, 0, 0);
      this.start_time = this.formatDateLocal(start);
    
      const end = new Date(this.endFilterDate);
      end.setHours(23, 59, 0, 0);
      this.end_time = this.formatDateLocal(end);
    } else {
      const start = new Date();
      start.setDate(start.getDate() - 7);
      start.setHours(0, 0, 0, 0);
      this.start_time = this.formatDateLocal(start);
      this.startFilterDate = this.start_time;
    
      const end = new Date();
      end.setHours(23, 59, 0, 0);
      this.end_time = this.formatDateLocal(end);
      this.endFilterDate = this.end_time;
    }
    let post_type = this.selectedFilter === 'Post type' ? undefined : this.selectedFilter;
    const requestLimit = this.limit + 1;
    this.postHubService.getPostByBotId(botId, this.postListType, requestLimit, this.offset, this.start_time, this.end_time, post_type).subscribe(
      (res) => {
        const hasMoreItems = res.body.data.length > this.limit;
        this.allBotPosts = hasMoreItems ? res.body.data.slice(0, this.limit) : res.body.data;
        if (hasMoreItems) {
          this.totalItems = this.offset + this.limit + 1;
        } else {
          this.totalItems = this.offset + res.body.data.length;
        }
        this.uniquePostTypes = [...new Set(this.allBotPosts.map(post => post.type))];
        if (this.allBotPosts) {
          for (let i = 0; i < this.allBotPosts.length; i++) {
            this.allBotPosts[i].totalReaction = 0;
            if (this.allBotPosts[i]?.reactions) {
              for (let reaction in this.allBotPosts[i].reactions) {
                this.allBotPosts[i].totalReaction += this.allBotPosts[i].reactions[reaction];
              }
            }
          }
        }
        this.allPostMasterData = this.allBotPosts;
      }
    )

  }

  goToPage(page: number) {
    this.currentPage = page;
    this.getPostByBotId(this.botSelected);
  }

  get totalPages(): number {
    return Math.ceil(this.totalItems / (this.limit));
  }
  
  get visiblePages(): number[] {
    const pages = [];
    pages.push(1);
    let start = Math.max(this.currentPage - 1, 2);
    let end = Math.min(start + this.visiblePageCount - 1, this.totalPages - 1);
    if (this.totalPages - end < 1) {
      start = Math.max(this.totalPages - this.visiblePageCount, 2);
      end = this.totalPages - 1;
    }
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    if (this.totalPages > 1) {
      pages.push(this.totalPages);
    }
    return pages;
  }

  onFilterSelect(type){
    this.selectedFilter = type;
    this.getPostByBotId(this.botSelected);
    let baseArray = this.allPostMasterData;
      if (this.startFilterDate && this.endFilterDate) {
        const startTime = new Date(this.startFilterDate).getTime();
        const endTime = new Date(this.endFilterDate).getTime();
        baseArray = baseArray.filter((post) => {
          let date = new Date(post.created_at);
          date.setHours(0, 0, 0, 0);
          let createdTime = date.getTime();
          return createdTime >= startTime && createdTime <= endTime;
        });
      }
      if (this.searchValue) {
        baseArray = baseArray.filter((post) => post.content.toLowerCase().includes(this.searchValue.toLowerCase()));
      }
      this.allBotPosts = baseArray.filter(post => post.type === type);
      this.totalItems = this.allBotPosts.length;
  }

  onRemoveFilter() {
    this.selectedFilter = 'Post type';
    this.getPostByBotId(this.botSelected);
    let baseArray = this.allPostMasterData;
      if (this.startFilterDate && this.endFilterDate) {
        const startTime = new Date(this.startFilterDate).getTime();
        const endTime = new Date(this.endFilterDate).getTime();
        baseArray = baseArray.filter((post) => {
          let date = new Date(post.created_at);
          date.setHours(0, 0, 0, 0);
          let createdTime = date.getTime();
          return createdTime >= startTime && createdTime <= endTime;
        });
      }
      if (this.searchValue) {
        baseArray = baseArray.filter((post) => post.content.toLowerCase().includes(this.searchValue.toLowerCase()));
      }
      this.allBotPosts = baseArray;
      this.totalItems = this.allBotPosts.length;
  }

  sortAccToStartTime() {
    if (this.sortIconStartTimeSrc === "assets/uparrow.svg") {
      this.sortIconStartTimeSrc = 'assets/down-arrow.svg'
      this.allBotPosts.sort((a, b) => {
        const startTimeA = new Date(a.created_at).getTime();
        const startTimeB = new Date(b.created_at).getTime();
        return startTimeA - startTimeB;
      });
    }
    else {
      this.sortIconStartTimeSrc = 'assets/uparrow.svg'
      this.allBotPosts.sort((a, b) => {
        const startTimeA = new Date(a.created_at).getTime();
        const startTimeB = new Date(b.created_at).getTime();
        return startTimeB - startTimeA;
      });
    }

  }
  sortAccToReatctions() {
    if (this.sortIconReactionSrc === "assets/uparrow.svg") {
      this.sortIconReactionSrc = 'assets/down-arrow.svg'
      this.allBotPosts.sort((a, b) => {
        const reacA = a.totalReaction;
        const reacB = b.totalReaction;
        return reacA - reacB;
      });
    }
    else {
      this.sortIconReactionSrc = 'assets/uparrow.svg'
      this.allBotPosts.sort((a, b) => {
        const recA = a.totalReaction;
        const recB = b.totalReaction;
        return recB - recA;
      });
    }


  }
  triggerSearchFunction() {
    if(this.searchValue=='') {
      let baseArray = this.allBotPosts;
      if (this.selectedFilter !== 'Post type') {
        baseArray = baseArray.filter(post => post.type === this.selectedFilter);
      }
      if (this.startFilterDate && this.endFilterDate) {
        const startTime = new Date(this.startFilterDate).getTime();
        const endTime = new Date(this.endFilterDate).getTime();
        baseArray = baseArray.filter((post) => {
          let date = new Date(post.created_at);
          date.setHours(0, 0, 0, 0);
          let createdTime = date.getTime();
          return createdTime >= startTime && createdTime <= endTime;
        });
      }
      this.allBotPosts = baseArray;
    } else {
        let baseArray = this.allPostMasterData;
        if (this.selectedFilter !== 'Post type') {
          baseArray = baseArray.filter(post => post.type === this.selectedFilter);
        }
        if (this.startFilterDate && this.endFilterDate) {
          const startTime = new Date(this.startFilterDate).getTime();
          const endTime = new Date(this.endFilterDate).getTime();
          baseArray = baseArray.filter((post) => {
            let date = new Date(post.created_at);
            date.setHours(0, 0, 0, 0);
            let createdTime = date.getTime();
            return createdTime >= startTime && createdTime <= endTime;
          });
        }
        this.allBotPosts = baseArray.filter((post) => post.content.toLowerCase().includes(this.searchValue.toLowerCase()));
    }
    this.totalItems = this.allBotPosts.length;

  }
  duplicatePost(postId) {
    let url = `/post-hub/create-post/${this.botSelected}/${postId}`;
    if (this.postListType === 'Published') url += '/false';
    else url += '/true';
    this.router.navigateByUrl(url);
  }

  downloadCSV() {
    let startTime = new Date(this.startFilterDate).getTime();
    let endTime = new Date(this.endFilterDate).getTime();
    if(startTime > endTime){
      this._snackBar.open('Start time can not be greater than end time', 'close', {
        duration: 3000,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition
      })
    }
    else {
      let post_type = this.selectedFilter === 'Post type' ? undefined : this.selectedFilter;
    this.postHubService.getMerchantPost(this.botSelected, this.start_time , this.end_time , post_type).subscribe(
      (res)=> {
        if(res.body.data.length < 1){
          this._snackBar.open('No posts to Download', 'close', {
            duration: 3000,
            horizontalPosition: this.horizontalPosition,
            verticalPosition: this.verticalPosition
          })
        } else {
          const jsonData = this.convertToCSV(res.body.data);
          this.downloadFile(jsonData);
        }
      },
      (error) => {
        this._snackBar.open(error.error.message, 'close', {
          duration: 3000,
          horizontalPosition: this.horizontalPosition,
          verticalPosition: this.verticalPosition
        })
      }
    )
    }
  }

  convertToCSV(data: any[]): string {
    const headers = [
      'Post_ID',
      'Post_Type',
      'Post_Title',
      'Views',
      'Published_Date',
      'Topic_uuid',
      'Topic_name',
      'Topic_isDeleted',
      'Images',
      'Deep_Link_url',
      'Deep_Link_text',
      'Reactions_like',
      'Reactions_celebrate',
      'Reactions_wow',
      'Reactions_insightful',
      'Reactions_funny',
      'Expires_At',
      'Status',
      'Thumbnail',
      'Video_URL',
      'Protocol',
      'Poll_Type',
      'Option_text',
      'Option_uuid',
      'Option_votes',
      'Option_answers',
      'Correct_Option_uuid',
      'Explanation'
    ];
  
    const rows: string[][] = [];
  
    data.forEach((post) => {
      const imageArray = Array.isArray(post.images) ? post.images : [''];
      const baseRow = [
        post.post_id ?? '',
        post.type ?? '',
        post.content ?? '',
        post.view_count ?? '',
        post.created_at ?? '',
        post.topic?.uuid ?? '',
        post.topic?.name ?? '',
        post.topic?.is_deleted ?? '',
        '',
        post.deep_link?.url ?? '',
        post.deep_link?.text ?? '',
        post.reactions?.like ?? '',
        post.reactions?.celebrate ?? '',
        post.reactions?.wow ?? '',
        post.reactions?.insightful ?? '',
        post.reactions?.funny ?? '',
        post.expires_at ?? '',
        this.postListType,
        post.thumbnail ?? '',
        post.url ?? '',
        post.protocol ?? '',
        post.poll_type ?? '',
      ];
  
      const correctOptionUuid = post.correct_option_uuid ?? '';
      const explanation = post.explanation ?? '';
      imageArray.forEach((imageUrl, imgIndex) => {
        const imageRow = [...baseRow];
        imageRow[8] = imageUrl;
        if (Array.isArray(post.options) && post.options.length > 0) {
          post.options.forEach((option, index) => {
            const optionText = option.text ?? '';
            const optionUuid = option.uuid ?? '';
            const optionVotes = option.votes ?? '';
            const optionAnswers = option.answers ?? '';
    
            if (index === 0) {
              rows.push([
                ...imageRow,
                optionText,
                optionUuid,
                optionVotes,
                optionAnswers,
                correctOptionUuid,
                explanation
              ]);
            } else {
              rows.push([
                ...imageRow,
                optionText,
                optionUuid,
                optionVotes,
                optionAnswers,
                '',
                ''
              ]);
            }
          });
        } else {
          rows.push([
            ...imageRow,
            '',
            '',
            '',
            '',
            ''
          ]);
        }
      })
    });
  
    const wrapLongText = (text: string, chunkSize: number = 200): string => {
      if (!text) return '';
      const result: string[] = [];
      for (let i = 0; i < text.length; i += chunkSize) {
        result.push(text.substring(i, i + chunkSize));
      }
      return result.join('\n');
    };
    const escapeCSVValue = (value: any) => {
      if (value === null || value === undefined) return '';
      let str = String(value);
      if (str.length > 200) {
        str = wrapLongText(str);
      }
      if (/[",\n\r]/.test(str)) {
        return `"${str.replace(/"/g, '""')}"`;
      }
      return str;
    };
    const csvContent = [
      headers.map(escapeCSVValue).join(','),
      ...rows.map(row => row.map(escapeCSVValue).join(','))
    ];
    return csvContent.join('\n');
  }

  downloadFile(csvContent: string) {
    const blob = new Blob([csvContent], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const start_date = new Date(this.start_time).toLocaleDateString('en-CA');
    const end_date = new Date(this.end_time).toLocaleDateString('en-CA');
    a.download = `posts_export_${start_date}_to_${end_date}.csv`;
    a.click();
    window.URL.revokeObjectURL(url);
  }
  
  deletePost(postId) {
    this.postHubService.deletePost(postId,this.botSelected, this.postListType).subscribe((res) => {},
    (error) => {
      if(error.status === 200){
        this.getAllBotDetails();
        this._snackBar.open("Successfully deleted post", 'close', {
          duration: 3000,
          horizontalPosition: this.horizontalPosition,
          verticalPosition: this.verticalPosition
        })
      }
      else{
        this._snackBar.open(error.error.message, 'close', {
        duration: 3000,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition
      })
      }
    }
    )
  }
  filterOnStartandEndDate(){
    if(this.startFilterDate=="" || this.endFilterDate=="") return;
    let startTime = new Date(this.startFilterDate).getTime();
    let endTime = new Date(this.endFilterDate).getTime();
    if(startTime<=endTime){
      this.getPostByBotId(this.botSelected);
      let baseArray = this.allPostMasterData;
      if (this.selectedFilter !== 'Post type') {
        baseArray = baseArray.filter(post => post.type === this.selectedFilter);
      }
      if (this.searchValue) {
        baseArray = baseArray.filter((post) => post.content.includes(this.searchValue));
      }
      this.allBotPosts = baseArray.filter((post)=>{
        let date = new Date(post.created_at);
        date.setHours(0, 0, 0, 0);
        let createdTime = date.getTime();
        return createdTime>=startTime && createdTime<=endTime;
      })
      this.totalItems = this.allBotPosts.length;
    } else {
      this._snackBar.open("Start time can not be greater than End time", 'close', {
        duration: 3000,
        horizontalPosition: this.horizontalPosition,
        verticalPosition: this.verticalPosition,
      });
      this.allBotPosts = [];
      this.totalItems = 0;
    }

  }
  resetFilterVariables(){
    this.startFilterDate = "";
    this.endFilterDate = "";
    this.searchValue = null;
    this.currentPage = 1;
    this.selectedFilter = 'Post type';
    this.getPostByBotId(this.botSelected);
    this.allBotPosts = this.allPostMasterData;
    this.totalItems = this.allBotPosts.length;
  }
  changePostListType(type){
    this.postListType = type==1 ? 'Published' : 'Scheduled'
    this.getPostByBotId(this.botSelected);
    this.resetFilterVariables()
  }    

  onFilterStartDateChange(event){
    this.filterOnStartandEndDate();    
  }
  onFilterEndDateChange(event){
    this.filterOnStartandEndDate();    
  }

  getPostLink(postId: string) {
    return `${environment.swiftchatURL}/feed?q=/post/${postId}`;
  }

}